
<stat-item
  class="showcase-owner-item"
  :as="isPublic ? 'nuxt-link' : 'router-link'"
  label="Owner"
  :value="owner.displayName || 'Anonymous'"
  :to="`/showcase/${owner.uid}`"
>
  <template #before>
    <avatar v-if="owner.photoUrl" :image-url="owner.photoUrl" />
  </template>
</stat-item>
